/** The name of the module */
export const name = 'Css';
/**
 * Adds a modifier to a CSS class name according to the Durango Framework naming convention
 *
 * @param {String} className - The base class name
 * @param {String} modifier - The modifier to be added
 *
 * @return {String} The formatted class name
 *
 * @example
 * classNameWithModifer('az-c-exampleThing', 'disabled'); // Outputs 'az-c-exampleThing--disabled'
 */
export function classNameWithModifier(className, modifier) {
    if (!modifier.match(/^[a-z0-9]+$/i)) {
        throw new TypeError('Invalid modifier provided — Modifier must contain only alphanumeric characters');
    }
    if (className.includes('--')) {
        return className;
    }
    return `${className}--${modifier}`;
}
/**
 * Adds a subclass to a CSS class name according to the Durango Framework naming convention
 *
 * @param className The base class name
 * @param subClassName The modifier to be added
 *
 * @example
 * classNameWithSubClass('az-c-exampleThing', 'title'); // Outputs 'az-c-exampleThing_title'
 */
export function classNameWithSubClass(className, subClassName) {
    if (!subClassName.match(/^[a-z0-9]+$/i)) {
        throw new TypeError('Invalid subclass provided — Subclass must contain only alphanumeric characters');
    }
    if (className.includes('_')) {
        return className;
    }
    return `${className}_${subClassName}`;
}
/**
 * Adds the given CSS class name to each given element
 *
 * @param elements
 * @param className
 */
export function addClassToElements(elements, className) {
    for (const element of elements) {
        element.classList.add(className);
    }
}
/**
 * Removes the given CSS class name from each given element
 *
 * @param elements
 * @param className
 */
export function removeClassFromElements(elements, className) {
    for (const element of elements) {
        element.classList.remove(className);
    }
}
